<page-toolbar [pageActions]="pageActions" title="{{'pages.my-packages' | translate}} {{currentPage.title}}: {{getTitle()}}"></page-toolbar>

<mat-tab-group (selectedTabChange)="tabChange($event)" [selectedIndex]="currentIndex">
  <mat-tab *ngFor="let page of pages;" [label]="page.title">
    <app-package-general *ngIf="page.type === 'general'" [onSave]="triggerAction$.asObservable()"></app-package-general>

    <app-package-installed-apps-manager *ngIf="page.type === 'app-manager'" [onSave]="triggerAction$.asObservable()"></app-package-installed-apps-manager>

    <app-package-seasonal-images *ngIf="page.type === 'images'" [onSave]="triggerAction$.asObservable()"></app-package-seasonal-images>

    <app-package-screen-images *ngIf="page.type === 'screen'" [onSave]="triggerAction$.asObservable()" [noHeader]="true"></app-package-screen-images>

    <app-package-legal *ngIf="page.type === 'legal'" [onSave]="triggerAction$.asObservable()" [noHeader]="true"></app-package-legal>

    <app-package-editor *ngIf="page.type === 'meta-config'" [onSave]="triggerAction$.asObservable()"></app-package-editor>

    <app-package-editor-ibexsmart *ngIf="page.type === 'ibexsmart'" [onSave]="triggerAction$.asObservable()"></app-package-editor-ibexsmart>

    <app-package-editor-ibextouch *ngIf="page.type === 'ibextouch'" [onSave]="triggerAction$.asObservable()"></app-package-editor-ibextouch>

    <app-package-editor-ibexinfo *ngIf="page.type === 'ibexinfo'" [onSave]="triggerAction$.asObservable()"></app-package-editor-ibexinfo>

    <app-package-editor-ibextablet *ngIf="page.type === 'ibextablet'" [onSave]="triggerAction$.asObservable()"></app-package-editor-ibextablet>

    <app-package-editor-ibextv *ngIf="page.type === 'ibextv'" [onSave]="triggerAction$.asObservable()"></app-package-editor-ibextv>

    <app-import-logs *ngIf="page.type === 'logs'" [id]="packageId" type="package"></app-import-logs>
  </mat-tab>
</mat-tab-group>
